// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ReadingProgressController from "./reading_progress_controller"
application.register("reading-progress", ReadingProgressController)

import SmartImageController from "./smart_image_controller"
application.register("smart-image", SmartImageController)
